import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({
  title = 'Ener Otomasyon - Enerji Otomasyonu, Senkronizasyon Panosu, SCADA',
  description = 'Ener Otomasyon; enerji otomasyonu, senkronizasyon, senkron panosu, Woodward, Easygen, Deif, AGC150, ComAp, DeepSea, senkron kartı ve SCADA çözümleri sunar.',
  keywords = 'ener otomasyon, enerji otomasyonu, senkronizasyon, senkron panosu, woodward, easygen, deif, agc150, comap, deepsea, senkron kartı, scada, eselfware',
  image = 'https://www.enerotomasyon.com.tr/og-image.jpg',
  type = 'website',
  author = 'Ener Otomasyon',
  canonicalUrl,
  noindex = false,
  schema,
}) => {
  const location = useLocation();
  const baseUrl = 'https://www.enerotomasyon.com.tr';
  const currentUrl = canonicalUrl || `${baseUrl}${location.pathname}`;
  
  const defaultSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'Ener Otomasyon Elektrik San. Tic. Ltd. Şti.',
    description: description,
    url: baseUrl,
    logo: 'https://www.enerotomasyon.com.tr/ener-logo.png',
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+90-232-433-1435',
      contactType: 'Customer Service',
      areaServed: 'TR',
      availableLanguage: ['Turkish', 'English'],
    },
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Fatih Mah, 1197. Sk. No:2/1, Sarnıç',
      addressLocality: 'Gaziemir',
      addressRegion: 'İzmir',
      addressCountry: 'TR',
    },
    sameAs: [
      'https://www.linkedin.com/company/ener-otomasyon',
      'https://twitter.com/enerotomasyon',
    ],
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={currentUrl} />
      
      {/* Robots */}
      <meta name="robots" content={noindex ? 'noindex,nofollow' : 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1'} />
      <meta name="googlebot" content={noindex ? 'noindex,nofollow' : 'index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1'} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content="Ener Otomasyon" />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:locale:alternate" content="en_US" />
      <meta property="og:image:alt" content="Ener Otomasyon - Enerji otomasyonu ve senkronizasyon çözümleri" />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      
      {/* Additional SEO Tags */}
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="language" content="Turkish" />
      <meta name="geo.region" content="TR-35" />
      <meta name="geo.placename" content="İzmir" />
      <meta name="geo.position" content="38.4237;27.1428" />
      <meta name="ICBM" content="38.4237, 27.1428" />
      <link rel="alternate" hrefLang="tr-TR" href={currentUrl} />
      <link rel="alternate" hrefLang="x-default" href={currentUrl} />
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(schema || defaultSchema)}
      </script>
    </Helmet>
  );
};

export default SEO;
